import React from 'react';

export default function CbamLogo() {
  return (
    <svg
      width="162"
      height="50"
      viewBox="0 0 162 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3244 10.7585C15.8209 10.7585 19.706 13.4161 21.5341 17.2654C18.6533 23.876 11.3852 25.5379 5.56835 22.6263C11.3241 22.2345 15.4106 20.9907 17.1069 17.2673C15.7161 15.6066 13.6416 14.5518 11.3244 14.5518C7.59669 14.5518 4.49649 17.2798 3.86203 20.8726C6.45154 17.3811 9.67118 16.2476 13.4133 17.0679C7.66687 16.7917 4.63732 20.3894 4.63732 24.075C4.63732 28.3195 8.87859 30.442 12.3162 30.442C16.457 30.442 20.9288 27.9836 22.593 23.3697C22.0304 29.1739 17.1991 33.7102 11.3241 33.7102C5.07111 33.7102 0 28.5713 0 22.2345C0 15.8976 5.07135 10.7585 11.3244 10.7585Z"
        fill="#2E3342"
      />
      <path
        d="M51.0162 33.0281H45.7558V21.7042C45.7558 19.917 45.2996 18.5086 44.3872 17.4792C43.4748 16.4354 42.2416 15.9135 40.6877 15.9135C39.0911 15.9135 37.808 16.464 36.8386 17.565C36.5591 17.8783 36.3198 18.2231 36.1209 18.5995L35.9671 13.3773C36.4746 12.896 37.0431 12.4904 37.6726 12.1604C38.9414 11.4884 40.424 11.1524 42.1205 11.1524C44.8861 11.1524 47.0602 11.9959 48.6426 13.6831C50.225 15.3702 51.0162 17.7008 51.0162 20.6747V33.0281Z"
        fill="#2E3342"
      />
      <path
        d="M33.7127 11.5813L34.3444 33.0281H30.124V11.5813H33.7127Z"
        fill="#2E3342"
      />
      <path
        d="M70.7419 33.0281L63.0531 11.5813H57.4494L66.2596 33.0281H70.7419Z"
        fill="#2E3342"
      />
      <path
        d="M72.4207 30.4255L80.1806 11.5813H74.578L70.127 24.0276L72.4207 30.4255Z"
        fill="#2E3342"
      />
      <path
        d="M90.356 5.89788C89.6147 5.89788 88.9874 5.64052 88.4742 5.12579C87.9753 4.59677 87.7258 3.96051 87.7258 3.21702C87.7258 2.48783 87.9753 1.86587 88.4742 1.35115C88.9874 0.822129 89.6147 0.557618 90.356 0.557618C91.1116 0.557618 91.746 0.822129 92.2592 1.35115C92.7724 1.86587 93.029 2.48783 93.029 3.21702C93.029 3.96051 92.7724 4.59677 92.2592 5.12579C91.746 5.64052 91.1116 5.89788 90.356 5.89788Z"
        fill="#2E3342"
      />
      <path
        d="M87.7258 33.0281V11.5813H92.9863V33.0281H87.7258Z"
        fill="#2E3342"
      />
      <path
        d="M107.335 33.0281H102.264V11.5813H106.703L107.335 33.0281Z"
        fill="#2E3342"
      />
      <path
        d="M109.094 17.9954C109.499 17.5039 109.974 17.0887 110.518 16.75C111.473 16.1638 112.578 15.8707 113.832 15.8707C114.659 15.8707 115.514 15.9993 116.398 16.2567L117.04 11.4955C116.598 11.3811 116.149 11.2953 115.693 11.2381C115.251 11.1809 114.816 11.1524 114.388 11.1524C112.749 11.1524 111.295 11.5312 110.026 12.289C109.643 12.5204 109.284 12.7804 108.949 13.0691L109.094 17.9954Z"
        fill="#2E3342"
      />
      <path d="M129.268 33.0281H123.644V0H129.268V33.0281Z" fill="#2E3342" />
      <path
        d="M147.741 43.7515H142.247L155.516 11.5813H161.02L147.741 43.7515Z"
        fill="#2E3342"
      />
      <path
        d="M141.881 11.5813L147.731 24.0658L145.202 30.198L135.958 11.5813H141.881Z"
        fill="#2E3342"
      />
      <path
        d="M0.455 44.45C0.455 43.5573 0.654333 42.76 1.053 42.058C1.46033 41.3473 2.01067 40.797 2.704 40.407C3.406 40.0083 4.19033 39.809 5.057 39.809C6.071 39.809 6.95933 40.069 7.722 40.589C8.48467 41.109 9.01767 41.8283 9.321 42.747H7.228C7.02 42.3137 6.72533 41.9887 6.344 41.772C5.97133 41.5553 5.538 41.447 5.044 41.447C4.51533 41.447 4.043 41.5727 3.627 41.824C3.21967 42.0667 2.899 42.4133 2.665 42.864C2.43967 43.3147 2.327 43.8433 2.327 44.45C2.327 45.048 2.43967 45.5767 2.665 46.036C2.899 46.4867 3.21967 46.8377 3.627 47.089C4.043 47.3317 4.51533 47.453 5.044 47.453C5.538 47.453 5.97133 47.3447 6.344 47.128C6.72533 46.9027 7.02 46.5733 7.228 46.14H9.321C9.01767 47.0673 8.48467 47.791 7.722 48.311C6.968 48.8223 6.07967 49.078 5.057 49.078C4.19033 49.078 3.406 48.883 2.704 48.493C2.01067 48.0943 1.46033 47.544 1.053 46.842C0.654333 46.14 0.455 45.3427 0.455 44.45ZM16.2835 44.346C16.7948 44.4413 17.2152 44.697 17.5445 45.113C17.8738 45.529 18.0385 46.0057 18.0385 46.543C18.0385 47.0283 17.9172 47.4573 17.6745 47.83C17.4405 48.194 17.0982 48.48 16.6475 48.688C16.1968 48.896 15.6638 49 15.0485 49H11.1355V39.926H14.8795C15.4948 39.926 16.0235 40.0257 16.4655 40.225C16.9162 40.4243 17.2542 40.7017 17.4795 41.057C17.7135 41.4123 17.8305 41.8153 17.8305 42.266C17.8305 42.7947 17.6875 43.2367 17.4015 43.592C17.1242 43.9473 16.7515 44.1987 16.2835 44.346ZM12.9555 43.67H14.6195C15.0528 43.67 15.3865 43.5747 15.6205 43.384C15.8545 43.1847 15.9715 42.903 15.9715 42.539C15.9715 42.175 15.8545 41.8933 15.6205 41.694C15.3865 41.4947 15.0528 41.395 14.6195 41.395H12.9555V43.67ZM14.7885 47.518C15.2305 47.518 15.5728 47.414 15.8155 47.206C16.0668 46.998 16.1925 46.7033 16.1925 46.322C16.1925 45.932 16.0625 45.6287 15.8025 45.412C15.5425 45.1867 15.1915 45.074 14.7495 45.074H12.9555V47.518H14.7885ZM25.313 47.271H21.699L21.101 49H19.19L22.453 39.913H24.572L27.835 49H25.911L25.313 47.271ZM24.819 45.815L23.506 42.019L22.193 45.815H24.819ZM39.2077 39.926V49H37.3877V43.098L34.9567 49H33.5787L31.1347 43.098V49H29.3147V39.926H31.3817L34.2677 46.673L37.1537 39.926H39.2077Z"
        fill="#2E3342"
      />
    </svg>
  );
}
